import React, { useEffect, useState } from 'react';
import { analyticsUserTrack } from "../config/analyticsTrack";
import "./GHT.css"
import Logo from './assets/logo.png'
import nairobi from './assets/nairobi.jpeg'
import nairobi2 from './assets/nairobi2.png'
import nairobi3 from './assets/nairobi3.png'
import GHTPhotoCollage from './assets/GiraffeNairobiimage1.jpg'
import Config from '../helper/Config';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Header from './components/Header';
import Footer from './Footer';

export default function NairobiJune2024(props) {
    const [showMenu, setShowMenu] = useState(false);


    useEffect(() => {
        analyticsUserTrack("GHT - Nairobi June 2024", "Landing");
        window.scrollTo(0, 0);
    }, [])

    return <div className='version-2 GHT nairobi-june'>
        <div className='block1' style={{ marginTop: 0 }}>
            <div className={`home-sticky-crop home`} style={{ top: 0 }}>
                <Link to={Config.projectUrl + "/GHT"} onClick={() => window.scrollTo(0, 0)}>
                    <img className='logo' src={Logo} />
                </Link>
                <Header page="social-impact" />
            </div>
        </div>
        <div style={{ marginTop: 95 }}></div>

        <div className='container' style={{ maxWidth: 800 }}>
            <div className='text-center' style={{ position: "relative"}}>
                <img className='img-fluid' src={GHTPhotoCollage} />
                <div className='montserrat-font-family' style={{ position: "absolute", bottom: 10, right: 10, fontWeight: "bold", color: "#fff"}}>
                GHT Consultation <br/>
                Nairobi, Kenya <br/>
                June 15, 2024
                </div>
            </div>
            <div className='row my-5'>
                <div className='col-sm-9'>
                    <p className='montserrat-font-family' style={{ color: "#0072ce", fontWeight: "bold", fontSize: 24 }}>
                        GHT Consultation <br />
                        Nairobi, Kenya - June 15, 2024
                    </p>
                    <br />
                    <p style={{ color: "#0072ce", fontWeight: "bold", fontSize: 18 }}>
                        GHT Theory of Change
                    </p>
                    <br />
                    <p>
                        Equitable healthcare systems are optimized when the global healthcare stakeholder community is consistently connected by reliable and user friendly communication.
                    </p>
                    <br />
                    <p style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                        GHT is advancing:
                    </p>
                    <ul style={{ marginLeft: '0em' }}>
                        <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', }}>
                            <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                                A (non-conflicted) community-led digital innovation
                                platform
                            </span>
                        </li>
                        <li style={{ color: 'rgb(52, 83, 81)', lineHeight: '22px', }}>
                            <span style={{ fontWeight: 400, color: 'rgb(52, 83, 81)' }}>
                                To facilitate a more globally connected ecosystem
                            </span>
                        </li>
                        <li style={{ color: 'rgb(52, 83, 81)', lineHeight: '22px', }}>
                            <span style={{ fontWeight: 400, color: 'rgb(52, 83, 81)' }}>
                                For all healthcare stakeholders
                            </span>
                        </li>
                        <li style={{ color: 'rgb(52, 83, 81)', lineHeight: '22px', }}>
                            <span style={{ fontWeight: 400, color: 'rgb(52, 83, 81)' }}>
                                To share knowledge, coordinate action, and drive equitable
                                system level improvement.
                            </span>
                        </li>
                    </ul>
                </div>
                <div className='col-sm-3'>
                    <img className='img-fluid' src={nairobi} />
                </div>
            </div>
            <div className='row my-5'>
                <div className='col-sm-3'>
                    <img className='img-fluid' src={nairobi2} />
                </div>
                <div className='col-sm-9'>
                    <p className="montserrat-font-family" style={{ color: "#0072ce", fontWeight: "bold", fontSize: 18 }}>
                        GHT Nairobi Consultation Agenda
                    </p>
                    <br />
                    <ol style={{ marginLeft: '0em', color: 'rgb(10, 78, 83)' }}>
                        <li>
                            <strong>Paul Young MD:</strong> Current Healthcare Connectivity Conundrum.
                        </li>
                        <li>
                            Participants:{' '}
                            <span style={{ color: 'rgb(245, 166, 35)', fontWeight: 700 }}>
                                Feedback on current gaps and best practices
                            </span>
                            .
                        </li>
                        <li>
                            <strong>Vidya Sri:</strong> Digital Equity & Innovation in Global Coalition Building.
                        </li>
                        <li>
                            <strong>Paul Young MD:</strong> Introduction of the GHT Innovation Platform.
                        </li>
                        <li>
                            <strong>Moody Qureshi MD:</strong>{' '}
                            <span style={{ color: 'rgb(245, 166, 35)', fontWeight: 700 }}>
                                Implementation Thoughts for East Africa.
                            </span>
                        </li>
                        <li>
                            Participants:{' '}
                            <span style={{ color: 'rgb(245, 166, 35)', fontWeight: 700 }}>
                                Feedback on what&apos;s needed to make this work
                            </span>
                            .
                        </li>
                        <li>
                            Everyone: Questions, suggestions, obstacles.
                        </li>
                    </ol>
                </div>
            </div>
            <div className='row my-5 d-flex'>
                <div className='col-sm-7'>
                    <p className='montserrat-font-family' style={{ color: "#0072ce", fontWeight: "bold", fontSize: 24 }}>
                        GHT Consultation Outcomes <br />
                        Nairobi, Kenya - June 15, 2024
                    </p>
                    <br />
                    <div >
                        <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', letterSpacing: '0em', textTransform: 'none' }}><br /></p>
                        <ul style={{ marginLeft: '0em' }}>
                            <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'disc' }}>
                                <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                                    75 Global neurosurgery stakeholders participated
                                </span>
                                <span>
                                    &nbsp; in the consultation (in person and remote).
                                </span>
                                <ul>
                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'circle' }}>
                                        <span>Feedback from participants on:</span>
                                        <ul style={{ marginLeft: '10px' }}>
                                            <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'square' }}>
                                                <span>Current healthcare connectivity best practices and gaps.</span>
                                            </li>
                                            <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'square' }}>
                                                <span>The GHT community-led innovation platform.</span>
                                            </li>
                                            <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'square' }}>
                                                <span>Potential implementation in East Africa.</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}><br /></p>

                        <ul style={{ marginLeft: '0em' }}>
                            <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'disc' }}>
                                <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                                    The GHT Working Group launched in August 2024
                                </span>
                                <span>{' '}with:</span>
                                <ul>
                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'circle' }}>
                                        <span>A statement of intention</span>
                                    </li>
                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'circle' }}>
                                        <span>A Terms of Reference</span>
                                    </li>
                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'circle' }}>
                                        <span>Training video for the GHT innovation platform</span>
                                        <ul>
                                            <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'square' }}>
                                                <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>4 sub-working groups</span>
                                                <span>{' '}focused on:</span>
                                                <ul>
                                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'disc' }}>
                                                        <span>Industry/Facility Surplus Supplies</span>
                                                    </li>
                                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'disc' }}>
                                                        <span>Facility Needs</span>
                                                    </li>
                                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'disc' }}>
                                                        <span>Supply/Demand Chain</span>
                                                    </li>
                                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'disc' }}>
                                                        <span>Volunteer Opportunities</span>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <p style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px' }}><br /></p>

                        <ul style={{ marginLeft: '0em' }}>
                            <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'disc' }}>
                                <span>
                                    George Handley, Working Group Member, is doing his&nbsp;
                                </span>
                                <span style={{ fontWeight: 700, color: 'rgb(245, 166, 35)' }}>
                                    MPH Practicum on a scalable model&nbsp;
                                </span>
                                <span>
                                    for the shipment,
                                    distribution, training, and maintenance of donated
                                    neurosurgical supplies to the region.
                                </span>
                                <ul>
                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'circle' }}>
                                        <span>Project Cure internship</span>
                                    </li>
                                    <li style={{ color: 'rgb(10, 78, 83)', lineHeight: '22px', listStyleType: 'circle' }}>
                                        <span>Teqbahn advisory partner</span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-sm-5 d-flex align-items-center'>
                    <img className='img-fluid' src={nairobi3} style={{ border: "4px solid #0072ce" }} />
                </div>
            </div>
        </div>
        <Footer />

    </div>
}
